import { BaseWebComponentElement } from '../../../../../../framework/BaseWebComponentElement';
import { TargetsGridController } from '../controller/TargetsGridController';

export class TargetsGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TargetsGridController,
    });
  }
}
